<template>
    <div class="flex items-center w-full space-x-2">
        <div class="grow-0">
            <icon
                v-if="props.status === 'pending'"
                icon="hero/outline/clock"
                class="w-6 h-6 text-gray-400"
            ></icon>
            <icon v-else-if="props.status === 'closed'" icon="hero/solid/check-circle" class="w-6 h-6 text-green-600"></icon>
            <icon
                v-else-if="props.status === 'active'"
                icon="hero/solid/chat-alt-2"
                class="w-6 h-6 text-blue-600"></icon>
            <icon
                v-else-if="props.status === 'idle'"
                icon="hero/outline/dots-circle-horizontal"
                class="w-6 h-6 text-gray-400"
            ></icon>
            <icon
                v-else-if="props.status === 'minimized'"
                icon="hero/outline/minus"
                class="w-6 h-6 text-gray-400"
            ></icon>
        </div>
        <div v-if="props.verbose" class="flex-auto text-sm">
            {{ lang(`chat::chat.status.${props.status}`) }}
        </div>
    </div>
</template>

<script lang="ts" setup>
interface Props {
    status?: string;
    verbose?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    status: 'idle',
    verbose: false,
});
</script>
